export const LANGUAGE_ALIASES = {
  py: "python",
  js: "javascript",
  ts: "typescript",
  sh: "shell",
  yml: "yaml",
} as const;

export const SUPPORTED_LANGUAGES = [
  "arduino",
  "bash",
  "c",
  "cpp",
  "csharp",
  "css",
  "diff",
  "go",
  "graphql",
  "ini",
  "java",
  "javascript",
  "json",
  "kotlin",
  "less",
  "lua",
  "makefile",
  "markdown",
  "objectivec",
  "perl",
  "php",
  "plaintext",
  "python",
  "r",
  "ruby",
  "rust",
  "scss",
  "shell",
  "sql",
  "swift",
  "typescript",
  "vbnet",
  "wasm",
  "xml",
  "yaml",
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export function getCanonicalLanguage(
  language: string | null | undefined,
): SupportedLanguage | null {
  const mapped =
    language && language in LANGUAGE_ALIASES
      ? LANGUAGE_ALIASES[language as keyof typeof LANGUAGE_ALIASES]
      : language;
  if (mapped && (SUPPORTED_LANGUAGES as readonly string[]).includes(mapped)) {
    return mapped as SupportedLanguage;
  }
  return null;
}

export function isExecutableLanguage(language: string | null | undefined): boolean {
  return getCanonicalLanguage(language) === "python";
}
